/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component } from "react";
import orderClasses from "../../orders/orders.module.css";
import reportClasses from "../reports.module.css";
import WorkOrderTable from "./workOrderReportTable";
import Input from "../../../../component/inputpm";
import Loader from "../../../../component/loader";
import IconButton from "@mui/material/IconButton";
import { connect } from "react-redux";
import actionTypes from "../../../../store/actions";
//import Select from '../../../component/select';
import Select from "@mui/material/Select";
import BusApiCall from "../../../../helper/axios";
import constants from "../../../../helper/constants";
import { withTranslation } from "react-i18next";
import Tooltip from "@mui/material/Tooltip";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import moment from "moment";
import Breadcrumb from "../../../../component/breadcrumb";
import Paper from "@mui/material/Paper";
import { SearchIcon, ClearIcon } from "../../../../component/icons/icons";
import { Grid } from "@mui/material";
// Manage order page class
class WorkOrderReport extends Component {
  // Declare property values that belongs to the component
  state = {
    workOrderList: [],
    rowsPerPage: 10,
    page: 1,
    startRecord: 1,
    totalOrderCount: 0,
    sortBy: "estimatedStartDate",
    sortOrder: "DESC",
    workOrderId: "",
    status: "",
    productName: "",
    productId: "",
    orderId: "",
    startFromDate: "",
    startToDate: "",

    statusList: [
      {
        name: "All",
        value: "",
      },
      {
        name: "Created",
        value: "PRUN_CREATED",
      },
      {
        name: "Scheduled",
        value: "PRUN_SCHEDULED",
      },
      {
        name: "Confirmed",
        value: "PRUN_DOC_PRINTED",
      },
      {
        name: "Running",
        value: "PRUN_RUNNING",
      },
      {
        name: "Completed",
        value: "PRUN_COMPLETED",
      },
      {
        name: "Closed",
        value: "PRUN_CLOSED",
      },
      {
        name: "Cancelled",
        value: "PRUN_CANCELLED",
      },
    ],
    bread: [{ title: "Work Orders", url: "/workOrders" }],
  };

  // Intial HTTP calls or data manipulation on page load
  componentDidMount() {
    this.props.setCompDidMount();
    this.getWorkOrderReport();
  }

  convertDateParam(date) {
    return moment(date).format("yyyy-MM-DDTHH:mm:ss:SSS+00:00");
  }

  convertTillDateParam(date) {
    return moment(date).format("yyyy-MM-DDT23:59:59:999+00:00");
  }

  // Fetch orders list
  getWorkOrderReport = () => {
    this.setState({
      loading: true,
    });
    let pageOptions = {
      batchSize: this.state.rowsPerPage,
      startRecord: this.state.startRecord,
    };

    var jsonData = {
      workOrderId: this.state.workOrderId,
      status: this.state.status === "All" ? "" : this.state.status,
      productName: this.state.productName,
      productId: this.state.productId,
      orderId: this.state.orderId,
      startFromDate: this.state.startFromDate
        ? encodeURIComponent(this.convertDateParam(this.state.startFromDate))
        : "",
      startToDate: this.state.startToDate
        ? encodeURIComponent(this.convertTillDateParam(this.state.startToDate))
        : "",
    };

    BusApiCall(
      "GET",
      `${constants.busInternalUrl}/reports?sortBy=${this.state.sortBy}&sortOrder=${this.state.sortOrder}&reportType=WORK_ORDER&jsonData=${JSON.stringify(jsonData)}`,
      {},
      pageOptions,
    )
      .then((res) => {
        //let data = JSON.parse(res);
        this.setState({
          workOrderList: res.data.workOrderReport.workorderList,
          totalOrderCount: +res.headers["x-total-count"],
          loading: false,
        });
      })
      .catch((e) => {
        if (e.response) {
          this.props.setErrorMessage(e.response.data.message, false);
        } else {
          this.props.setErrorMessage("Something went wrong", false);
        }
        this.setState({ loading: false });
      });
  };

  // Change page
  handleChangePage = (event, newPage) => {
    this.setState(
      {
        page: newPage,
        startRecord: this.state.rowsPerPage * (newPage - 1) + 1,
      },
      () => {
        this.getWorkOrderReport();
      },
    );
  };

  // Change rows per page
  handleChangeRowsPerPage = (event) => {
    this.setState(
      {
        page: 1,
        rowsPerPage: event.target.value,
        startRecord: 1,
      },
      () => {
        this.getWorkOrderReport();
      },
    );
  };

  // Change table sorting
  updateSorting = (by) => {
    if (by === this.state.sortBy) {
      this.setState(
        {
          sortOrder: this.state.sortOrder === "DESC" ? "ASC" : "DESC",
          page: 1,
          startRecord: 1,
        },
        () => {
          this.getWorkOrderReport();
        },
      );
    } else {
      this.setState(
        {
          sortBy: by,
          sortOrder: "ASC",
          page: 1,
          startRecord: 1,
        },
        () => {
          this.getWorkOrderReport();
        },
      );
    }
  };

  // Update state data on input change
  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  // Search/Filter orders
  filterTable = () => {
    this.props.setErrorMessage("", false);
    this.setState(
      {
        page: 1,
        startRecord: 1,
        // customerBan: '',
        // customerName: '',
        // featureCode: '',
        // settlementId: '',
        // itemDescription: '',
      },
      () => {
        this.getWorkOrderReport();
      },
    );
  };

  // Clear all search filters
  clearFilters = () => {
    this.props.setErrorMessage("", false);
    this.setState(
      {
        workOrderId: "",
        status: "",
        productName: "",
        productId: "",
        orderId: "",
        startFromDate: "",
        startToDate: "",
        page: 1,
        startRecord: 1,
      },
      () => {
        this.getWorkOrderReport();
      },
    );
  };

  // Search orders on press enter key
  onSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      this.filterTable();
    }
  };

  classes = { ...orderClasses, ...reportClasses };

  // Render order view
  render() {
    const { t } = this.props;
    return (
      <div className={"newContentWrapper"}>
        <div className={"breadcrumbWrapper"}>
          <div className={"breadcrumbContent"}>
            <Grid container>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <Breadcrumb list={this.state.bread} />
              </Grid>
            </Grid>
          </div>
        </div>
        <main>
          <Paper className="tablePaper" elevation={0}>
            {/* Search filters start */}
            <div className={this.classes.searchOuterDiv}>
              <div>
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("ORDER_ID")}
                  value={this.state.orderId}
                  name={"orderId"}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  divClass={this.classes.ordInputClass}
                  onKeyDown={(e) => {
                    this.onSearchKeyDown(e);
                  }}
                />
              </div>
              <div>
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("WORK_ORDER_ID")}
                  value={this.state.workOrderId}
                  name={"workOrderId"}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  divClass={this.classes.inputClass}
                  onKeyDown={(e) => {
                    this.onSearchKeyDown(e);
                  }}
                />
              </div>
              <div>
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("PRODUCT_ID")}
                  value={this.state.productId}
                  name={"productId"}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  divClass={this.classes.inputClass}
                  onKeyDown={(e) => {
                    this.onSearchKeyDown(e);
                  }}
                />
              </div>
              <div>
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("PRODUCT_NAME")}
                  value={this.state.productName}
                  name={"productName"}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  divClass={this.classes.inputClass}
                  onKeyDown={(e) => {
                    this.onSearchKeyDown(e);
                  }}
                />
              </div>
              <div>
                <FormControl
                  variant="outlined"
                  className="custom-select-input"
                  size={"small"}
                >
                  <InputLabel htmlFor="status">{t("STATUS")}</InputLabel>
                  <Select
                    native
                    label="status"
                    value={this.state.status}
                    onChange={(e) => {
                      this.onChange(e);
                    }}
                    onKeyDown={(e) => {
                      this.onSearchKeyDown(e);
                    }}
                    inputProps={{
                      name: "status",
                      id: "status",
                    }}
                  >
                    {this.state.statusList.map((opt, key) => (
                      <option key={key} value={opt.name}>
                        {opt.name}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              </div>
              <div>
                <TextField
                  name="startFromDate"
                  id="date"
                  type="date"
                  value={this.state.startFromDate}
                  label={t("START_FROM")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  variant={"outlined"}
                  size={"small"}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  inputProps={{ max: this.state.startFromDate }}
                />
              </div>

              <div>
                <TextField
                  name="startToDate"
                  id="date"
                  type="date"
                  value={this.state.startToDate}
                  label={t("START_TO")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  variant={"outlined"}
                  size={"small"}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  inputProps={{ min: this.state.startToDate }}
                />
              </div>

              {/* <div className={this.classes.searchOrderLabelOuter} style={{ paddingRight: 0 }}>
                                <div className={this.classes.searchOrderLabelInner} style={{ paddingRight: 0 }}> */}
              <div style={{ display: "flex", alignItems: "flex-start" }}>
                <Tooltip title={t("SEARCH")}>
                  <IconButton
                    className="iconButtonSecondary"
                    onClick={this.filterTable}
                  >
                    <SearchIcon />
                  </IconButton>
                </Tooltip>{" "}
                &nbsp;
                <Tooltip title={t("CLEAR")}>
                  <IconButton
                    className="iconButtonSecondary"
                    onClick={this.clearFilters}
                  >
                    <ClearIcon />
                  </IconButton>
                </Tooltip>
              </div>
              {/* </div> */}
            </div>
            {/* Search filters end */}

            {/* Order table component */}
            <WorkOrderTable
              list={this.state.workOrderList}
              rowsPerPage={this.state.rowsPerPage}
              totalOrderCount={this.state.totalOrderCount}
              page={this.state.page}
              handleChangePage={this.handleChangePage}
              handleChangeRowsPerPage={this.handleChangeRowsPerPage}
              sortBy={this.state.sortBy}
              sortOrder={this.state.sortOrder}
              updateSorting={this.updateSorting}
            />
          </Paper>
          <Loader loading={this.state.loading} />
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loggedInUserId: state.auth.loggedInUserId,
    loggedInUserType: state.auth.userLoginType,
  };
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(WorkOrderReport));
